import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setDialogs } from '../../../actions';
import { getHost } from '../../../const';
import { query } from '../../../lib/util/common';
import { post } from '../../../lib/kbApp/kbJsBridgePromise';
import { getSchemeHeader } from '../../../lib/util/utils';
import { ActionSuccessDialog, ActionFalseDialog } from '../../../components';
import { getWelfareCenterParams, getSignTaskAction, setWelfareAnimation, getMyIntegralAction } from '../../../rootStore';
import { showTip } from '../../../lib/util/domUtil.js';
import './index.scss';

class OpenRedpackDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      withdrawLock: false,
    };

    this.Log = this.props.Log;
  }

  componentDidMount() {
  }

	close = () => {
	  this.props.dialogs.pop();
	  this.props.dispatch(setDialogs(this.props.dialogs));

	  setWelfareAnimation();
	  getMyIntegralAction();
	}

	// 跳转到旧版邀请详情页
	toInviteFriend = () => {
	  const url = `${getHost()}/welfare/inviteFriend?refer=welfare_new`;
	  window.location.href = `${getSchemeHeader()}://webview?url=${encodeURIComponent(url)}&innerfrom=welfare_new`;

	  this.close();
	}

	// 提现
	withdraw = () => {
	  const { extraInfo = {}, isWelfareNeedReceive = false, taskId } = this.props.signTask;
	  const receiveInfo = extraInfo.receiveInfo ? JSON.parse(extraInfo.receiveInfo) : {};
	  const { canReceive, min = 0, balance = 0 } = receiveInfo;

	  if (isWelfareNeedReceive) {  // 可直接提现
	    if (canReceive === true) {
	      const param = Object.assign(getWelfareCenterParams(), {
	        taskId,
	        refer: query('refer'),
	      });
	      param.accountType = param.type || '';

	      if (this.state.withdrawLock) {
	        return;
	      }

	      this.state.withdrawLock = true;
	      post(`${getHost()}/newtickets/api/signInWithdraw`, param).then((res) => {
	          this.state.withdrawLock = false;
	          getSignTaskAction(); // 更新页面状态
	          this.props.dialogs.pop();

	          if (res.code === 0) {
	            const len = this.props.dialogs.length;
	            this.props.dispatch(setDialogs(this.props.dialogs.concat([
								<ActionSuccessDialog key={len} from="signInMoney" title={`已成功提现${balance / 100}元至微信`} subTitle="24小时内即可到账，请放心"></ActionSuccessDialog>,
	            ])));

	            this.Log && this.Log.sendExposure({
	              element_type: 'cashsign',
	              element_name: 'cashsign_popup_withdraw_success',
	            });
	          } else {
	            const len = this.props.dialogs.length;
	            this.props.dispatch(setDialogs(this.props.dialogs.concat([
								<ActionFalseDialog key={len} title="很抱歉，提现失败" subTitle="你的账户存在异常，无法提现" history={this.props.history}></ActionFalseDialog>,
	            ])));

	            this.Log && this.Log.sendExposure({
	              element_type: 'cashsign',
	              element_name: 'cashsign_popup_withdraw_fail',
	            });
	          }
	        });
	    } else {
	      showTip(`${min / 100}元就可提现啦`, 3000);
	      this.props.dialogs.pop();
	    }
	  } else {
	    this.props.dialogs.pop();
	    this.toWithdraw();
	  }
	}

	// 去提现
	toWithdraw = () => {
	  this.props.history.push({ pathname: '/withDraw' });
	}

	// 老版提现
	toOldWithdraw = () => {
	  const url = `${getHost()}/welfare/withdraw?refer=welfare_new`;
	  window.location.href = `${getSchemeHeader()}://webview?url=${encodeURIComponent(url)}&innerfrom=welfare_new`;
	}

	// 红包弹窗内容
	contentRender = () => {
	  const { num, desc, from } = this.props;

	  return (
			<React.Fragment>
				<div className="money">
					<span className="num">{num}</span>元
				</div>
				<div className="tip">{desc}</div>
				{from === 'inviteCode'
				  ? <div className="withdraw" onClick={() => this.toInviteFriend()} log-click-eltype="confirm">查看现金余额</div>
				  :					<div className="withdraw" onClick={() => this.withdraw()} log-click-eltype="confirm">立即提现</div>
				}
			</React.Fragment>
	  );
	}

	render() {
	  return (
			<div className="openRedpackDialog">
				<div className="redpack">
					<div className="redpackGet">
						{this.contentRender()}
					</div>
					<div className="close" onClick={this.close} log-click-eltype="close"></div>
				</div>
			</div>
	  );
	}
}

const mapStateToProps = (state) => {
  const { dialogs, signTask } = state;
  return {
    dialogs,
    signTask,
  };
};

export default connect(mapStateToProps)(withRouter(OpenRedpackDialog));
